export const STOCK_STATUS = {
  IN_STOCK: 'in stock',
  OUT_OF_STOCK: 'out of stock'
}
